var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center text-xs font-normal leading-normal text-red-600 min-h-6"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.message))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }